import { motion } from 'framer-motion'
import { CalendlyBtn } from '@/components/ui/calendly-btn'
import { process } from '@/content/site'

const stepColors = ['bg-blue-600', 'bg-indigo-600', 'bg-violet-600', 'bg-purple-600']

export default function Process() {
  return (
    <section className="py-24 lg:py-32 bg-slate-50 dark:bg-slate-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-2"
          >
            {process.heading}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-xl text-slate-500 dark:text-slate-400"
          >
            {process.subheading}
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {process.steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-100 dark:border-slate-700 flex flex-col gap-4"
            >
              <div className={`${stepColors[i]} w-10 h-10 rounded-xl flex items-center justify-center text-white font-bold text-sm`}>
                {i + 1}
              </div>
              <h3 className="font-semibold text-slate-900 dark:text-white text-lg">{step.title}</h3>
              <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">{step.body}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <CalendlyBtn size="lg" className="bg-blue-600 hover:bg-blue-700 text-white border-transparent">
            {process.cta}
          </CalendlyBtn>
        </motion.div>
      </div>
    </section>
  )
}
